import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      nav("/admin");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--secondary))]/40 px-6" data-testid="login-page">
      <div className="w-full max-w-md bg-card border border-border rounded-2xl p-10 shadow-sm">
        <div className="text-center">
          <div className="w-12 h-12 rounded-full bg-[hsl(var(--primary))] mx-auto flex items-center justify-center relative">
            <span className="absolute w-4 h-4 rounded-full bg-[hsl(var(--accent))]" />
            <span className="absolute w-1.5 h-1.5 rounded-full bg-white" />
          </div>
          <div className="overline mt-6">Admin Portal</div>
          <h1 className="font-serif text-3xl mt-2">Shantanu Netralaya CMS</h1>
          <p className="text-sm text-muted-foreground mt-2">Sign in to manage content.</p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
            <LogIn size={16} /> {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <div className="mt-6 text-center">
          <Link to="/" className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--primary))]" data-testid="login-back-home">← Back to site</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
